<template>
  <div class="slider" ref="slider">
    <div class="process" :style="{width}"></div>
    <div class="thunk" ref="trunk" :style="{left}">
      <div class="block"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['min', 'max', 'value'],
  data () {
    return {
      slider: null, // 滚动条DOM元素
      thunk: null, // 拖拽DOM元素
      curValue: this.value, // 当前值
      scale: 0
    }
  },
  mounted () {
    this.slider = this.$refs.slider
    this.thunk = this.$refs.trunk

    this.thunk.ontouchstart = (e) => {
      const width = parseInt(this.width)
      const disX = e.touches[0].clientX
      document.ontouchmove = (e) => {
        const newWidth = e.changedTouches[0].clientX - disX + width
        this.calNewValue(newWidth)
      }
      document.ontouchend = function () {
        document.ontouchmove = document.ontouchend = null
      }
      return false
    }

    this.slider.ontouchend = (e) => {
      const newWidth = e.changedTouches[0].clientX - this.slider.getBoundingClientRect().left - this.thunk.offsetWidth / 2
      this.calNewValue(newWidth)
    }
  },
  watch: {
    value (val) {
      this.curValue = val
      this.scale = (this.curValue - this.min) / (this.max - this.min)
    }
  },
  computed: {
    width () {
      if (this.slider) {
        return (this.slider.offsetWidth * this.scale) + 'px'
      } else {
        return 0 + 'px'
      }
    },
    left () {
      if (this.slider) {
        return parseInt(this.slider.offsetWidth * this.scale - this.thunk.offsetWidth / 2) + 'px'
      } else {
        return 0 + 'px'
      }
    }
  },
  methods: {
    calNewValue (newWidth) {
      const scale = newWidth / this.slider.offsetWidth
      this.curValue = Math.ceil((this.max - this.min) * scale + this.min)
      this.curValue = Math.max(this.curValue, this.min)
      this.curValue = Math.min(this.curValue, this.max)
      this.$emit('change', this.curValue)
    }
  }
}
</script>
<style lang="stylus" scoped>
.slider
  position relative
  width 100%
  height 4px
  background #9776A9
  .process
    position absolute
    left 0
    top 0
    width 0
    height 4px
    background #fff
  .thunk
    position absolute
    left 0
    top -8px
    width 20px
    height 20px
  .block
    position absolute
    left 4px
    top 4px
    width 12px
    height 12px
    border-radius 50%
    background #fff
</style>
